module.exports = __webpack_public_path__ + "static/img/activity1.64c8be4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/aboutWe/activity1.jpg
// module id = XziB
// module chunks = 3